import * as React from 'react';
import {Component} from 'react';
import Tab from './Tab';
import TabPanel from './TabPanel';

// usage example:
// <Tabs selectedKey="F"
// 		 tabs={[{key: 'F', title: 'first'},{key: 'S', title: 'second'}]}
// 	  	 onSelect={(key,disableCallback) => {console.log('selected key:' + key)}}>
// 	  <TabPanel key="F">
// 	  	<p>My first content</p>
// 	  </TabPanel>
// 	  <TabPanel key="F">
// 	  	<p>My second content</p>
// 	  </TabPanel>
// </Tabs>

interface TabsProps {
    tabs: {key: string; title: string}[];
    disabled: boolean;
    selectedKey: string;
    oneScreenStore: boolean;
    hiddenMenu: boolean; // Don't show the menu at all. This props comes from GWT.
    children: React.ReactElement<TabPanel>[];
    onSelect(key: string): void;
}

export default class Tabs extends Component<TabsProps, null> {
    constructor(props) {
        super(props);

        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(key: string) {
        const {onSelect} = this.props;
        onSelect(key);
    }

    getChildren() {
        const {selectedKey, children} = this.props;

        return React.Children.map(children, (child: React.ReactElement<any>) => {
            const selected = child.key === selectedKey;
            return child && React.cloneElement(child, {selected});
        });
    }

    render() {
        const {tabs, selectedKey, disabled, hiddenMenu, oneScreenStore} = this.props;
        return (
            <div className="tabs-wrapper">
                {!hiddenMenu && !oneScreenStore && (
                    <div className="menu">
                        {tabs.map(({key, title}) => (
                            <Tab
                                key={key}
                                tabFor={key}
                                selected={selectedKey === key}
                                disabled={disabled}
                                onSelect={this.handleSelect}
                            >
                                {title}
                            </Tab>
                        ))}
                        <div className="selected-mark" />
                    </div>
                )}
                {this.getChildren()}
            </div>
        );
    }
}

export {TabPanel};
